import { Injectable } from '@angular/core';

import { IndexedDBDatabase } from '../../../helpers/indexeddb/indexeddb.database';
import { HubStoreDatabase } from '../../../helpers/indexeddb/databases/hub-store.database';

@Injectable({ providedIn: 'root' })
export class IndexedDBService {

    public static dbs: Record<string, IndexedDBDatabase> = {
        hubStore: new HubStoreDatabase(),
    };
}
